var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$userIsAdmin
    ? _c("div", { staticClass: "container-fluid" }, [
        _vm.$userIsGlobalAdmin && _vm.regionOptions.length > 1
          ? _c("div", { staticClass: "row" }, [
              _c("h2", [_vm._v("Filters")]),
              _vm._v(" "),
              !_vm.$vlastMode
                ? _c("div", { staticClass: "col-sm-6 col-md-4" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", [_vm._v("Region")]),
                        _vm._v(" "),
                        _c("selectize", {
                          ref: "regions",
                          staticClass: "selectize selectize-single",
                          attrs: {
                            name: "region",
                            placeholder: "Region",
                            options: _vm.regionOptions,
                          },
                          on: { input: _vm.getFilteredData },
                          model: {
                            value: _vm.selectedRegion,
                            callback: function ($$v) {
                              _vm.selectedRegion = $$v
                            },
                            expression: "selectedRegion",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$vlastMode && _vm.$showDepartmentField
                ? _c("div", { staticClass: "col-sm-6 col-md-4" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", [_vm._v("Departments")]),
                        _vm._v(" "),
                        _c("selectize", {
                          staticClass: "selectize selectize-single",
                          attrs: {
                            name: "departmentId",
                            "pre-load": true,
                            "fetch-results": _vm.getDepartmentIdOptions,
                            "fetch-more-results":
                              _vm.getMoreDepartmentIdOptions,
                            options: this.departmentOptions,
                          },
                          on: { input: _vm.getFilteredData },
                          model: {
                            value: _vm.departmentId,
                            callback: function ($$v) {
                              _vm.departmentId = $$v
                            },
                            expression: "departmentId",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$vlastMode && _vm.$showCategoryStats
                ? _c("div", { staticClass: "col-sm-6 col-md-4" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", [_vm._v("Categories")]),
                        _vm._v(" "),
                        _c("selectize", {
                          staticClass: "selectize selectize-single",
                          attrs: {
                            name: "categoryId",
                            "pre-load": true,
                            "fetch-results": _vm.getCategoryIdOptions,
                            "fetch-more-results": _vm.getMoreCategoryIdOptions,
                            options: this.categoryOptions,
                          },
                          on: { input: _vm.getFilteredData },
                          model: {
                            value: _vm.categoryId,
                            callback: function ($$v) {
                              _vm.categoryId = $$v
                            },
                            expression: "categoryId",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$vlastMode
                ? _c("div", { staticClass: "col-sm-6 col-md-4" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", [_vm._v("Organisations")]),
                        _vm._v(" "),
                        _c("selectize", {
                          staticClass: "selectize selectize-single",
                          attrs: {
                            name: "organisationName",
                            "pre-load": true,
                            "fetch-results": _vm.getOrganisationNameOptions,
                            "fetch-more-results":
                              _vm.getMoreOrganisationNameOptions,
                            options: this.organisationOptions,
                          },
                          on: { input: _vm.getFilteredData },
                          model: {
                            value: _vm.organisationName,
                            callback: function ($$v) {
                              _vm.organisationName = $$v
                            },
                            expression: "organisationName",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-sm-6" },
            [
              _c("h2", [_vm._v("Weekly Activity")]),
              _vm._v(" "),
              _vm._l(_vm.metrics, function (metric, key) {
                return _vm.metrics
                  ? _c("MetricCard", {
                      key: key,
                      attrs: {
                        metric: metric,
                        "style-options": "col-xs-12 col-sm-6 col-md-6",
                      },
                    })
                  : _vm._e()
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-sm-6" },
            [
              _c("h2", [_vm._v("Annual Booking Count")]),
              _vm._v(" "),
              _vm._l(_vm.annual, function (metric, key) {
                return _c("MetricCard", {
                  key: key,
                  attrs: {
                    metric: metric,
                    "style-options": "col-xs-12 col-sm-6 col-md-6",
                  },
                })
              }),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-6" },
            [
              _c("datetime-line-chart", {
                key: JSON.stringify(this.prevParams),
                staticClass: "chart-card",
                attrs: {
                  filterParams: this.prevParams,
                  uniqueName: "star_signups",
                  type: "single",
                  showBrush: false,
                  chartOpenByDefault: true,
                  channelData: false,
                  name:
                    _vm.$options.filters.sentenceCase(_vm.$starLabel) +
                    " Signups",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-6" },
            [
              _c("datetime-line-chart", {
                key: JSON.stringify(this.prevParams),
                staticClass: "chart-card",
                attrs: {
                  filterParams: this.prevParams,
                  uniqueName: "client_signups",
                  type: "single",
                  showBrush: false,
                  chartOpenByDefault: true,
                  channelData: false,
                  name: _vm.$activeClientModuleEnabled
                    ? this.$t("Client") + " Signups"
                    : this.$t("Clients") + " Created",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-6" },
            [
              _c("datetime-line-chart", {
                key: JSON.stringify(this.prevParams),
                staticClass: "chart-card",
                attrs: {
                  filterParams: this.prevParams,
                  uniqueName: "manager_signups",
                  type: "single",
                  showBrush: false,
                  chartOpenByDefault: true,
                  channelData: false,
                  name: "Manager Signups",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _vm._m(1),
          _vm._v(" "),
          _vm.$vlastMode && _vm.$showDepartmentField
            ? _c(
                "div",
                { staticClass: "col-xs-12" },
                [
                  _c("scatterplot", {
                    key: JSON.stringify(this.prevParams),
                    staticClass: "chart-card",
                    attrs: {
                      filterParams: this.prevParams,
                      showBrush: true,
                      uniqueName: "total_hours_per_player",
                      name: "hours_booked_per_" + _vm.$starLabel,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$vlastMode && _vm.$showDepartmentField
            ? _c(
                "div",
                { staticClass: "col-xs-12" },
                [
                  _c("bar-chart", {
                    key: JSON.stringify(this.prevParams),
                    staticClass: "chart-card",
                    attrs: {
                      filterParams: this.prevParams,
                      showBrush: false,
                      uniqueName: "booking_request_by_opportunity_type",
                      name: _vm.$t("requests") + "_by_summary",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$vlastMode && _vm.$showStateStats
            ? _c(
                "div",
                { staticClass: "col-xs-12" },
                [
                  _c("bar-chart", {
                    key: JSON.stringify(this.prevParams),
                    staticClass: "chart-card",
                    attrs: {
                      filterParams: this.prevParams,
                      uniqueName: "completed_booking_requests_by_state",
                      showBrush: false,
                      name: "completed_" + _vm.$t("requests") + "_by_state",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$vlastMode && _vm.$showStateStats
            ? _c(
                "div",
                { staticClass: "col-xs-12" },
                [
                  _c("bar-chart", {
                    key: JSON.stringify(this.prevParams),
                    staticClass: "chart-card",
                    attrs: {
                      filterParams: this.prevParams,
                      uniqueName: "budget_per_state",
                      showBrush: false,
                      name: "committed_booking_budget_per_state",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$vlastMode && _vm.$showStateStats
            ? _c(
                "div",
                { staticClass: "col-xs-12" },
                [
                  _c("grouped-bar-chart", {
                    key: JSON.stringify(this.prevParams),
                    staticClass: "chart-card",
                    attrs: {
                      filterParams: this.prevParams,
                      uniqueName:
                        "completed_booking_requests_by_state_by_category",
                      showBrush: false,
                      name:
                        "completed_" +
                        _vm.$t("requests") +
                        "_by_state_by_category",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$vlastMode && _vm.$showDepartmentField
            ? _c(
                "div",
                { staticClass: "col-xs-12" },
                [
                  _c("bar-chart", {
                    key: JSON.stringify(this.prevParams),
                    staticClass: "chart-card",
                    attrs: {
                      filterParams: this.prevParams,
                      uniqueName: "budget_by_player",
                      showBrush: false,
                      name: "budget_by_" + _vm.$starLabel,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$vlastMode && _vm.$showDepartmentField
            ? _c(
                "div",
                { staticClass: "col-xs-12" },
                [
                  _c("bar-chart", {
                    key: JSON.stringify(this.prevParams),
                    staticClass: "chart-card",
                    attrs: {
                      filterParams: this.prevParams,
                      uniqueName: "pending_requests_by_player",
                      showBrush: false,
                      name:
                        "pending_" +
                        _vm.$t("requests") +
                        "_by_" +
                        _vm.$starLabel,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$vlastMode && _vm.$showDepartmentField
            ? _c(
                "div",
                { staticClass: "col-xs-12" },
                [
                  _c("bar-chart", {
                    key: JSON.stringify(this.prevParams),
                    staticClass: "chart-card",
                    attrs: {
                      filterParams: this.prevParams,
                      uniqueName: "total_hours_per_department",
                      showBrush: false,
                      name: "hours_per_department",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$vlastMode && _vm.$showDepartmentField
            ? _c(
                "div",
                { staticClass: "col-xs-12" },
                [
                  _c("bar-chart", {
                    key: JSON.stringify(this.prevParams),
                    staticClass: "chart-card",
                    attrs: {
                      filterParams: this.prevParams,
                      uniqueName: "booking_request_by_department",
                      showBrush: false,
                      name: _vm.$t("requests") + "_by_department",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$vlastMode && _vm.$showDepartmentField
            ? _c(
                "div",
                { staticClass: "col-xs-12" },
                [
                  _c("grouped-bar-chart", {
                    key: JSON.stringify(this.prevParams),
                    staticClass: "chart-card",
                    attrs: {
                      filterParams: this.prevParams,
                      uniqueName: "booking_request_by_player_by_category",
                      showBrush: false,
                      name:
                        _vm.$t("requests") +
                        "_by_" +
                        _vm.$starLabel +
                        "_by_category",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$vlastMode && _vm.$showDepartmentField
            ? _c(
                "div",
                { staticClass: "col-xs-12" },
                [
                  _c("grouped-bar-chart", {
                    key: JSON.stringify(this.prevParams),
                    staticClass: "chart-card",
                    attrs: {
                      filterParams: this.prevParams,
                      uniqueName: "booking_total_budget_by_player_by_category",
                      showBrush: false,
                      name:
                        "booking_total_budget_by_" +
                        _vm.$starLabel +
                        "_by_category",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$vlastMode && _vm.$showDepartmentField
            ? _c(
                "div",
                { staticClass: "col-xs-12" },
                [
                  _c("datetime-line-chart", {
                    key: JSON.stringify(this.prevParams),
                    staticClass: "chart-card",
                    attrs: {
                      filterParams: this.prevParams,
                      uniqueName: "completed",
                      type: "single",
                      showBrush: false,
                      channelData: false,
                      name: "completed",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.$vlastMode
            ? _c(
                "div",
                { staticClass: "col-xs-12" },
                [
                  _c("datetime-line-chart", {
                    key: JSON.stringify(this.prevParams),
                    staticClass: "chart-card",
                    attrs: {
                      filterParams: this.prevParams,
                      uniqueName: "leads",
                      type: "single",
                      showBrush: false,
                      channelData: false,
                      name: "leads",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.$vlastMode
            ? _c(
                "div",
                { staticClass: "col-xs-12" },
                [
                  _c("datetime-line-chart", {
                    key: JSON.stringify(this.prevParams),
                    staticClass: "chart-card",
                    attrs: {
                      filterParams: this.prevParams,
                      uniqueName: "requests",
                      type: "single",
                      showBrush: false,
                      channelData: false,
                      name: _vm.$t("requests"),
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$paymentsModuleEnabled
            ? _c(
                "div",
                { staticClass: "col-xs-12" },
                [
                  _c("datetime-line-chart", {
                    key: JSON.stringify(this.prevParams),
                    staticClass: "chart-card",
                    attrs: {
                      filterParams: this.prevParams,
                      uniqueName: "invoices",
                      type: "single",
                      showBrush: false,
                      channelData: false,
                      name: "invoices",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$vlastMode
            ? _c(
                "div",
                { staticClass: "col-xs-12" },
                [
                  _vm._m(2),
                  _vm._v(" "),
                  _c("options-chart", {
                    key: JSON.stringify(this.prevParams),
                    attrs: {
                      filterParams: this.prevParams,
                      options: [
                        {
                          type: "multi",
                          showBrush: true,
                          name: "In Person",
                          uniqueName: "requests_by_type",
                          height: 280,
                        },
                        {
                          type: "multi",
                          showBrush: true,
                          name: "Online",
                          uniqueName: "online_requests_by_type",
                          height: 280,
                        },
                      ],
                    },
                  }),
                ],
                1
              )
            : _c(
                "div",
                [
                  _vm._m(3),
                  _vm._v(" "),
                  _c("options-chart", {
                    key: JSON.stringify(this.prevParams),
                    attrs: {
                      filterParams: this.prevParams,
                      options: [
                        {
                          type: "multi",
                          showBrush: true,
                          name: "Leads by channel",
                          height: 280,
                          uniqueName: "leads_by_channel",
                        },
                        {
                          type: "multi",
                          showBrush: true,
                          name: _vm.$t("Requests") + " by channel",
                          height: 280,
                          uniqueName: "requests_by_channel",
                        },
                        {
                          type: "multi",
                          showBrush: true,
                          name: "Invoices by channel",
                          height: 280,
                          uniqueName: "invoices_by_channel",
                        },
                      ],
                    },
                  }),
                ],
                1
              ),
        ]),
      ])
    : _vm.$userIsClient &&
      _vm.$vlastMode &&
      _vm.$showClientBIBudgetPerStateEnabled
    ? _c("div", { staticClass: "container-fluid" }, [
        _vm._m(4),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-xs-12" },
            [
              _c("bar-chart", {
                key: JSON.stringify(this.prevParams),
                staticClass: "chart-card",
                attrs: {
                  filterParams: this.prevParams,
                  uniqueName: "budget_per_state",
                  showBrush: false,
                  chartOpenByDefault: true,
                  channelData: false,
                  isChartOpen: true,
                  name: "committed_booking_budget_per_state",
                },
              }),
            ],
            1
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-sm-12" }, [
      _c("h2", [_vm._v("User Activity")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-sm-12" }, [
      _c("h2", [_vm._v("Additional Charts")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-sm-12" }, [
      _c("h2", [_vm._v("Opportunity Type Breakdown")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-sm-12" }, [
      _c("h2", [_vm._v("Channel Breakdown")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c("h2", [_vm._v("User Activity")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }